import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { ConfigKeyFE_SourceTagId, ModuleFE_Tag, ModuleFE_Variable } from '../../../../../_entity.js';
import { DefaultEditor_InputText } from '@app/styles/frontend/ui-manager/ui-components';
import { DropDown_ResourceType } from '../../../../../_entity/resource/ui-components.js';
import { DropDown_Tag } from '../../../../../_entity/tag/ui-components.js';
import { MultiSelect_Variable } from '../../../../../_entity/variable/ui-components.js';
import { MultiSelect_Tag } from '../../../../../_entity/tag/ui-components.js';
import { FadeScrollWrapper } from '@app/styles';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { viewMode_Edit, viewMode_View } from '@app/styles';
import { QuaiManager_DropDownCaret } from '@app/styles/frontend/ui/ui-manager/consts';
import './Editor_Resource.scss';
export class Editor_Resource extends ComponentSync {
    shouldComponentUpdate() {
        return true;
    }
    render() {
        return _jsxs(FadeScrollWrapper, { className: 'e__resource', children: [this.renderField_Label(), this.renderField_Type(), this.renderField_Tag(), this.renderField_VariableProperties(), this.renderField_TagsProperties(), this.props.isNewResource && this.renderField_SaveButton()] });
    }
    renderField_Label = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Resource Name', children: _jsx(DefaultEditor_InputText, { editable: this.props.editable, prop: 'label', disabled: !this.props.editMode, showErrorTooltip: true }) });
    };
    renderField_Type = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Type', children: _jsx(DropDown_ResourceType.editable, { editable: this.props.editable, prop: 'type', showErrorTooltip: true, disabled: !this.props.editMode }) });
    };
    renderField_Tag = () => {
        const sourceTagId = ConfigKeyFE_SourceTagId.get();
        if (!sourceTagId || sourceTagId.length === 0)
            return;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Tag', children: _jsx(DropDown_Tag.editable, { editable: this.props.editable, prop: 'tagId', queryFilter: (tag) => tag.tagIds.length === 1 && tag.tagIds.includes(sourceTagId), disabled: !this.props.editMode, showErrorTooltip: true, caret: QuaiManager_DropDownCaret }) });
    };
    renderField_VariableProperties = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Variable Properties', children: _jsx(Component_SwitchView, { mode: this.props.editMode ? viewMode_Edit : viewMode_View, modes: [
                    {
                        key: viewMode_View,
                        renderer: () => this.renderViewList(this.props.editable.item.variableProperties, (id) => ModuleFE_Variable.cache.unique(id)?.name ?? 'N/A'),
                    },
                    {
                        key: viewMode_Edit,
                        renderer: () => _jsx(MultiSelect_Variable, { editable: this.props.editable, prop: 'variableProperties' }),
                    },
                ] }) });
    };
    renderField_TagsProperties = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Tags Properties', children: _jsx(Component_SwitchView, { mode: this.props.editMode ? viewMode_Edit : viewMode_View, modes: [
                    {
                        key: viewMode_View,
                        renderer: () => this.renderViewList(this.props.editable.item.tagsProperties, (id) => ModuleFE_Tag.cache.unique(id)?.label ?? 'N/A'),
                    },
                    {
                        key: viewMode_Edit,
                        renderer: () => _jsx(MultiSelect_Tag, { editable: this.props.editable, prop: 'tagsProperties' }),
                    },
                ] }) });
    };
    renderViewList = (ids, labelResolver) => {
        if (!ids?.length)
            return _jsx("span", { className: 'e__resource__empty-field', children: "None" });
        return _jsx("div", { className: 'e__resource__tag-list', children: ids.map((id, i) => _jsx("span", { className: 'e__resource__tag-chip', children: labelResolver(id) }, i)) });
    };
    renderField_SaveButton = () => {
        return _jsx("button", { className: 'e__resource__save-btn', onClick: async () => await this.props.editable.save(), children: "Save" });
    };
}
//# sourceMappingURL=Editor_Resource.js.map